import { Component, OnInit } from '@angular/core';
import { AdsCampaign } from 'src/app/classes/ads-campaign';
import { AdsCampaignService } from 'src/app/services/ads-campaign.service';
import AdsCampaignTypes from 'src/app/constants/ads-campaign-types';
import AdsCampaignStatuses from 'src/app/constants/ads-campaign-statuses';

@Component({
  selector: 'app-recent',
  templateUrl: './recent.component.html',
  styleUrls: ['./recent.component.css']
})

export class RecentComponent implements OnInit {

  adsCampaigns: AdsCampaign[] = [];

  adsCampaignTypes = AdsCampaignTypes;
  adsCampaignStatuses = AdsCampaignStatuses;

  constructor(
    private adsCampaignService: AdsCampaignService
  ) { }

  ngOnInit(): void {
    this.adsCampaignService.recent().subscribe(adsCampaigns => {
      this.adsCampaigns = adsCampaigns;
    });
  }

  delete(id: number) {
    if(confirm($localize`Are you sure?`)) {
      this.adsCampaignService.delete(id).subscribe(() => {
        this.adsCampaignService.recent().subscribe(adsCampaigns => {
          this.adsCampaigns = adsCampaigns;
        });
      });
    }
  }
}
